import brochureToBookedCalendar from "./articles/brochure-website-to-booked-calendar-machine";
import { CATEGORIES, getCategory } from "./config";

/** All published articles, newest first. Add future articles by importing
 *  them and prepending to this array. */
export const ARTICLES = [brochureToBookedCalendar];

export const getArticleBySlug = (slug) =>
  ARTICLES.find((a) => a.slug === slug) || null;

/** Return the featured article (falls back to most recent). */
export const getFeaturedArticle = () =>
  ARTICLES.find((a) => a.featured) || ARTICLES[0] || null;

/** Articles excluding the one passed in, limited to `n`. Used for "related". */
export const getRelatedArticles = (slug, n = 3) =>
  ARTICLES.filter((a) => a.slug !== slug).slice(0, n);

export { CATEGORIES, getCategory };
